import React from "react";
import "../styles/footer.css"

const Footer = () => {
    return (
        <div className="footer-container">
            <div className="footer-mainlinks">
                <span>  <a style={{color:"white", textDecoration:"none"}} href="/homepage/#/kontakt/rezeptbestellung"> Rezeptbestellung </a></span>
                <span> <a style={{color:"white", textDecoration:"none"}} href="/homepage/#/kontakt">Kontaktformular  </a></span>
            </div>
            <div className="footer-secondary-info">
                <ul>
                    <li> Herzdoktor.net © 2025  </li>
                    <li> Kranzgasse 22/Hoftrakt, 1150 Wien </li>
                    <li> T. +43 1 892 17 17  </li>
                    <li> F. +43 720 72 00 111 </li>
                    <li> folgen Sie uns auf Instagram </li>
                    <li>
                        <a
                            href="/homepage/#/ordinationen"
                            style={{
                            color: "inherit",
                            textDecoration: "none",
                            }}
                        >
                            Impressum
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default Footer;